import localStorageWrapper from '../LocalStorageWrapper/LocalStorageWrapper';
import Constants, {HotjarTriggerNames} from '../../globals/Constants';
import MyWindow from '../../types/MyWindow';

declare const window: MyWindow;

const trigger = (triggerName: HotjarTriggerNames): void => {
   window.hj && window.hj(Constants.hotjarTrigger, triggerName);
};

const triggerAfterTimes = (userId: string, triggerName: HotjarTriggerNames, triggerLimit: number): void => {
   const localStorageKey = localStorageWrapper.getKey(Constants.localStorageKeys.hotjar, triggerName, userId);
   let triggerCount = parseInt(localStorageWrapper.getItem(localStorageKey), 10) || 0;

   if (triggerCount >= triggerLimit) {
      trigger(triggerName);
      return;
   }

   ++triggerCount;

   localStorageWrapper.setItem(localStorageKey, `${triggerCount}`);
};

const hideWidget = () => {
   const hjWidget = document.getElementById('_hj_feedback_container');

   if (hjWidget) {
      hjWidget.style.display = 'none';
   }
};

const showWidget = () => {
   const hjWidget = document.getElementById('_hj_feedback_container');

   if (hjWidget) {
      hjWidget.style.display = 'block';
   }
};

const startReviewModalClosed = (workflowStep: number): void => {
   if (workflowStep === 1) {
      trigger(HotjarTriggerNames.creationUploadAbandon);
   } else if (workflowStep === 2) {
      trigger(HotjarTriggerNames.creationDescribeAbandon);
   } else if (workflowStep === 3) {
      trigger(HotjarTriggerNames.creationInviteAbandon);
   }
};

const dashboardViewed = (isReviewsAtLimit: boolean, isTrialActive: boolean, userId: string): void => {
   if (isTrialActive) {
      triggerAfterTimes(userId, HotjarTriggerNames.dashboardTrialUsersHasUsed, 6);
   }

   if (isReviewsAtLimit) {
      trigger(HotjarTriggerNames.dashboardAllUsersHitMaxReviews);
   }
};

const startTrialModalClosed = (): void => {
   trigger(HotjarTriggerNames.modalStartTrialAbandon);
};

const buyNowModalClosed = (): void => {
   trigger(HotjarTriggerNames.modalBuyNowAbandon);
};

export default {
   startReviewModalClosed,
   dashboardViewed,
   startTrialModalClosed,
   buyNowModalClosed,
   hideWidget,
   showWidget
};
